
import axios from 'axios'

const _axios = axios.create()

_axios.interceptors.request.use((config) => ({
  ...config,
  timeout: 300000, //  5 minutes
  headers: {
    ...config.headers,
    'Content-Type': 'application/json; charset=UTF-8'
  }
}))

export default _axios
